<template>
  <b-modal
    id="videoModal"
    class="modal"
    v-model="isOpen"
    title="Video"
    hide-footer
    ok-only
    @ok="hideModal"
  >
    <b-embed type="video" id="videoSettings" controls>
      <source :src="video" type="video/mp4">
    </b-embed>
  </b-modal>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
export default {
  computed: mapState({
    isOpen: (state) => state.video.isOpen,
    video: (state) => state.video.source,
  }),
  methods: {
    hideModal: function () {
      $('#videoModal').modal('hide')
    },
    showModal: function () {
      $('#videoModal').modal('show')
    }
  }
}

</script>

<style scoped lang="scss">
.modal::v-deep {
  .modal-title {
    margin: -9px 0;
    justify-content: flex-start;
  }

  #videoSettings {
    width: 75%;
    height: 75%;
  }

  #video-modal-body {
    margin-left: auto;
    width: 75%;
    height: 75%;
  }

  .close {
    color: black;
    line-height: 0;
    margin-top: -15px;
  }
}


</style>
